import Cookies from "js-cookie";

export function cleanRET_APPandRET_DCCookie() {
    const cookieNames = ["LIVEFX_RET_DC", "LIVEFX_RET_APP"]; // Array of cookie names to delete
    cookieNames.forEach(name => {
        Cookies.remove(name)
    });
}
